var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { Button, Drawer, DrawerActions, DrawerContent, DrawerHeader, } from '@petsly/shared-client';
import { useDrawer } from 'context/DrawerContext';
import sharedMessages from 'translations/shared';
import NameField from './components/Name';
import LineOneField from './components/LineOne';
import LineTwoField from './components/LineTwo';
import CityField from './components/City';
import StateField from './components/State';
import PostalCodeField from './components/PostalCode';
import CountryField from './components/Country';
import IsDefaultLocationField from './components/IsDefaultLocation';
import IsBookableField from './components/IsBookable';
var View = function (_a) {
    var isProcessing = _a.isProcessing, onCreate = _a.onCreate;
    var closeDrawer = useDrawer().closeDrawer;
    var formatMessage = useIntl().formatMessage;
    var validationSchema = useMemo(function () {
        return yup.object().shape({
            name: yup.string().required(),
            line1: yup.string().required(),
            line2: yup.string().nullable(),
            city: yup.string().required(),
            state: yup.string().nullable(),
            country: yup.mixed().required(),
            postalCode: yup.string().required(),
            isDefaultLocation: yup.boolean().nullable(),
            isBookable: yup.boolean().nullable(),
        });
    }, []);
    var formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            name: '',
            line1: '',
            line2: '',
            city: '',
            state: '',
            country: 'PL',
            postalCode: '',
            isDefaultLocation: false,
            isBookable: false,
        },
        onSubmit: function (values) {
            onCreate(__assign(__assign({}, values), { isLocation: true }));
        },
    });
    var touched = formik.touched, errors = formik.errors, values = formik.values, setFieldValue = formik.setFieldValue, setFieldTouched = formik.setFieldTouched, submitForm = formik.submitForm;
    return (_jsxs(Drawer, __assign({ open: true, onDismiss: closeDrawer }, { children: [_jsx(DrawerHeader, __assign({ onClose: closeDrawer }, { children: formatMessage(sharedMessages.addLocation) }), void 0), _jsxs(DrawerContent, { children: [_jsx(NameField, { value: values.name, error: errors.name, touched: touched.name, onChange: function (value) { return setFieldValue('name', value); }, onBlur: function () { return setFieldTouched('name'); } }, void 0), _jsx(LineOneField, { value: values.line1, error: errors.line1, touched: touched.line1, onChange: function (value) { return setFieldValue('line1', value); }, onBlur: function () { return setFieldTouched('line1'); } }, void 0), _jsx(LineTwoField, { value: values.line2, error: errors.line2, touched: touched.line2, onChange: function (value) { return setFieldValue('line2', value); }, onBlur: function () { return setFieldTouched('line2'); } }, void 0), _jsx(CityField, { value: values.city, error: errors.city, touched: touched.city, onChange: function (value) { return setFieldValue('city', value); }, onBlur: function () { return setFieldTouched('city'); } }, void 0), _jsx(StateField, { value: values.state, error: errors.state, touched: touched.state, onChange: function (value) { return setFieldValue('state', value); }, onBlur: function () { return setFieldTouched('state'); } }, void 0), _jsx(PostalCodeField, { value: values.postalCode, error: errors.postalCode, touched: touched.postalCode, onChange: function (value) { return setFieldValue('postalCode', value); }, onBlur: function () { return setFieldTouched('postalCode'); } }, void 0), _jsx(CountryField, { value: values.country, error: errors.country, touched: touched.country, onChange: function (value) { return setFieldValue('country', value); }, onBlur: function () { return setFieldTouched('country'); } }, void 0), _jsx(IsDefaultLocationField, { value: values.isDefaultLocation, error: errors.isDefaultLocation, touched: touched.isDefaultLocation, onChange: function (value) { return setFieldValue('isDefaultLocation', value); }, onBlur: function () { return setFieldTouched('isDefaultLocation'); } }, void 0), _jsx(IsBookableField, { value: values.isBookable, error: errors.isBookable, touched: touched.isBookable, onChange: function (value) { return setFieldValue('isBookable', value); }, onBlur: function () { return setFieldTouched('isBookable'); } }, void 0)] }, void 0), _jsx(DrawerActions, { children: _jsx(Button, __assign({ onClick: submitForm, disabled: isProcessing, fullWidth: true }, { children: isProcessing
                        ? formatMessage(sharedMessages.loading)
                        : formatMessage(sharedMessages.save) }), void 0) }, void 0)] }), void 0));
};
export default View;
